<div class="popup-container">

<header>
  <label class="close_button" (click)="close()">x</label>
  <div class="header d-block roboto-medium">
    <label class="ms-3 mt-3 mb-3">{{ heading }}</label>
  </div>
</header>

<div
  class="body"
  [style]="errormsg ? 'margin: 1% 2% 0% 2%;' : 'margin: 1% 2% 2% 2%;'"
>
  <div class="row">
    {{ message }}
  </div>
</div>

<label *ngIf="errormsg" class="errormsg"> {{ errormsg }} </label>
<div
  class="
    footer
    d-flex
    justify-content-end
    align-items-center
    fixed-bottom
    mt-2
    pt-2
    pb-2
  "
>
  <button class="cancel me-3 roboto-bold" (click)="close()">CANCEL</button>
  <button
    *ngIf="type === 'reset'"
    class="submit black-button me-3 roboto-bold"
    (click)="resetClick()"
  >
    RESET
  </button>
  <button
    *ngIf="type === 'delete'"
    class="submit black-button me-3 roboto-bold"
    (click)="deleteClick()"
  >
    DISABLE
  </button>
</div>
</div>